// Libraries
import { startOfYear, endOfToday } from 'date-fns';
// Types
import { DatePickerState, Tables } from './datePickerStore.types';

// Shared default range: from start of current year to end of today
const defaultDateRange = {
  from: [startOfYear(new Date())],
  to: [endOfToday()],
};

const defaultValues = {
  availableYears: [],
  initialDate: defaultDateRange,
  selectedDate: defaultDateRange,
};

// Initial state for each table
export const initialState: DatePickerState = {
  [Tables.CII_FLEET_RATINGS]: defaultValues,
  [Tables.EEOI_SCORES]: defaultValues,
};
